"use client";

import { MainGallery } from "@/components/main-gallery";
import { MainGallerySelectors } from "@/components/main-gallery-selectors";
import { SecondaryHero } from "@/components/secondary-hero";
import { Section } from "@/components/ui/section";
import { Loader2 } from "lucide-react";
import { motion } from "motion/react";
import { Suspense } from "react";
import { EASE } from "@/lib/motion";

export default function Page() {
  return (
    <div className="flex flex-col">
      <SecondaryHero
        title="Galerija"
        description="Pogled u naš prostor, opremu i rezultate — fotografije svakodnevnog rada Dentalnog centra Dentivo."
      />

      <Section>
        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, ease: EASE }}
          className="flex flex-col gap-8 mx-auto w-full"
        >
          <Suspense
            fallback={
              <div className="flex items-center justify-center h-[750px]">
                <Loader2 className="size-10 animate-spin text-brand-800/50" />
              </div>
            }
          >
            <MainGallerySelectors />
            <MainGallery />
          </Suspense>
        </motion.div>
      </Section>
    </div>
  );
}
